import React from "react";
import { ReactLogo } from "./ReactLogo";

function Footer() {
  return (
    <div>
      <center>
        <footer>
          <div></div>
        </footer>
      </center>
    </div>
  );
}
export default Footer;
